module.exports = __webpack_public_path__ + "img/bronze_50x50.6c903709.png";